var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarChatDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12 9.097a1.095 1.095 0 1 1-2.19 0 1.095 1.095 0 0 1 2.19 0zM10.501 9.097a1.095 1.095 0 1 1-2.19 0 1.095 1.095 0 0 1 2.19 0zM13.787 10.192a1.095 1.095 0 1 0 0-2.19 1.095 1.095 0 0 0 0 2.19z",
    fill: "#007DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.016 17.642.022-.004c2.003-.397 3.229-.922 3.798-1.21a9.924 9.924 0 0 0 2.57.335c4.839 0 8.761-3.432 8.761-7.666 0-4.233-3.922-7.666-8.76-7.666-4.84 0-8.762 3.433-8.762 7.666 0 1.929.814 3.69 2.157 5.038-.08.844-.301 1.75-.573 2.539l-.004.012a11.971 11.971 0 0 1-.267.698c-.086.203.08.43.299.395a24.916 24.916 0 0 0 .759-.137zm.876-3.403a1.095 1.095 0 0 0-.314-.877C2.416 12.197 1.74 10.705 1.74 9.097c0-3.496 3.29-6.57 7.666-6.57s7.666 3.074 7.666 6.57c0 3.496-3.29 6.571-7.666 6.571a8.825 8.825 0 0 1-2.287-.298 1.095 1.095 0 0 0-.778.081c-.424.215-1.357.625-2.885.978.206-.704.367-1.462.436-2.19z",
    fill: "#007DD2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarChatDots);
export default __webpack_public_path__ + "static/media/star-chat-dots.63a67282ab2bb8deb75bcbe21c8dd3ac.svg";
export { ForwardRef as ReactComponent };